(function () {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('coc-agreement-invitation', {
                parent: 'app',
                url: '/coc/{secretKey}',
                data: {
                    authorities: [],
                    pageTitle: 'ipmApp.cocAgreement.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/coc-agreement-invitation/coc-agreement-invitation.html',
                        controller: 'CocAgreementInvitationController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('coc-agreement');
                        return $translate.refresh();
                    }],
                },
            });

    }

})();
